import { useLocation } from 'react-router';
import usePaywall from '../usePaywall';
import { useEffect } from 'react';
import { getAppRouteByPath } from '../../../../constants/appRoutes';
import { PageBlockLayout } from './page/PageBlockLayout';
import { PageblockHeaderWithCta } from './page/PageblockHeaderWithCta';
import { useIsSIUser } from '../../../pages/assessments/useIsSIUser';

const PaywallPageBlock = () => {
  const { pathname } = useLocation();
  const mainPath = pathname.split('/')[1];
  const appRoutePath = '/' + mainPath;
  const appRoute = getAppRouteByPath(appRoutePath);
  const pageblockData = appRoute?.pageblockData;
  const { sendEncounterPaywallEvent } = usePaywall();
  const isSIUser = useIsSIUser();

  useEffect(() => {
    sendEncounterPaywallEvent();
  }, [sendEncounterPaywallEvent, mainPath]);

  if (!pageblockData) {
    return null;
  }
  const { headerText, subHeaderText, imgSrc, imgAlt, name } = pageblockData.headerData;

  const buttonText = isSIUser ? 'Upgrade plan' : 'Start your trial';
  const bottomNote = isSIUser
    ? "You're on Sweep's Assessment Scan tier — unlock full platform access including AI agents, build capabilities, and more with an upgrade."
    : "You're on Sweep's free tier — unlock premium features like record updates, process orchestration, and integrations with a 14-day trial.";

  return (
    <PageBlockLayout
      pageblockData={pageblockData}
      header={
        <PageblockHeaderWithCta
          headerText={headerText}
          subHeaderText={subHeaderText}
          imgSrc={imgSrc}
          imgAlt={imgAlt}
          name={name}
          buttonText={buttonText}
          bottomNote={bottomNote}
        />
      }
    />
  );
};

export default PaywallPageBlock;
